export const bubbleCanvasDrillUpClass = 'bubble-canvas-can-drill-up';

export function syncBubbleCanvasDrillUpClass(container: HTMLElement, canDrillUp: boolean): void {
  container.classList.toggle(bubbleCanvasDrillUpClass, canDrillUp);
}

export function clearBubbleCanvasDrillUpClass(container: HTMLElement): void {
  container.classList.remove(bubbleCanvasDrillUpClass);
}
